module.exports = __webpack_public_path__ + "img/background.966e0809.png";